/* ───────────────────────────────────────────────
 * Nabi — on-scroll reveal animations
 * Adds `nabi-reveal--in` to elements with `nabi-reveal`
 * when they enter the viewport. Honors prefers-reduced-motion.
 * ─────────────────────────────────────────────── */

(function () {
  'use strict';

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add('nabi-reveal--in');
  }

  function init() {
    var targets = document.querySelectorAll('.nabi-reveal:not(.nabi-reveal--in)');
    if (!targets.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Auto-tag known section roots so client doesn't have to add the class manually */
  function autoTag() {
    var selectors = [
      '.nabi-products',
      '.nabi-cols',
      '.nabi-ritual',
      '.nabi-story',
      '.nabi-newsletter',
      '.nabi-footer',
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.classList.contains('nabi-reveal') && !el.classList.contains('nabi-reveal--in')) {
          el.classList.add('nabi-reveal');
        }
      });
    });
  }

  function boot() {
    autoTag();
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-run when Shopify section editor re-renders sections */
  document.addEventListener('shopify:section:load', boot);
})();
